import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const ContentStyled = styled(Flexer.Parent)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

export default ContentStyled;
